import { createStore } from "vuex";
import bootstrap from "bootstrap/dist/js/bootstrap.min.js";
import { API_ENDPOINTS, apiRequest, handleApiResponse } from "@/config/api.js";

export default createStore({
  state: {
    hideConfigButton: false,
    isPinned: false,
    isTransparent: "",
    isRTL: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    navbarFixed:
      "position-sticky blur shadow-blur left-auto top-1 z-index-sticky px-0 mx-4",
    absolute: "position-absolute px-4 mx-0 w-100 z-index-2",
    bootstrap,
    // Auth state
    user: null,
    token: localStorage.getItem('token') || null,
    isAuthenticated: false,
    authLoading: false,
  },
  mutations: {
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");
      if (!sidenav_show) return;
      if (sidenav_show.classList.contains("g-sidenav-pinned")) {
        sidenav_show.classList.remove("g-sidenav-pinned");
        sidenav_show.classList.add("g-sidenav-hidden");
        state.isPinned = false;
      } else {
        sidenav_show.classList.add("g-sidenav-pinned");
        sidenav_show.classList.remove("g-sidenav-hidden");
        state.isPinned = true;
      }
    },
    closeSidenavMobile(state) {
      if (!state.isPinned) return;
      const sidenav_show = document.querySelector(".g-sidenav-show");
      if (!sidenav_show) return;
      sidenav_show.classList.remove("g-sidenav-pinned");
      sidenav_show.classList.add("g-sidenav-hidden");
      state.isPinned = false;
    },
    sidebarType(state, payload) {
      state.isTransparent = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
    toggleEveryDisplay(state) {
      state.showNavbar = !state.showNavbar;
      state.showSidenav = !state.showSidenav;
      state.showFooter = !state.showFooter;
    },
    toggleHideConfig(state) {
      state.hideConfigButton = !state.hideConfigButton;
    },
    // Auth mutations
    SET_USER(state, user) {
      state.user = user;
      state.isAuthenticated = !!user;
    },
    SET_TOKEN(state, token) {
      state.token = token;
      if (token) {
        localStorage.setItem('token', token);
      } else {
        localStorage.removeItem('token');
      }
    },
    SET_AUTH_LOADING(state, loading) {
      state.authLoading = loading;
    },
    LOGOUT(state) {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    },
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    },
    // Auth actions
    async login({ commit }, credentials) {
      commit('SET_AUTH_LOADING', true);
      try {
        const response = await apiRequest(API_ENDPOINTS.LOGIN, {
          method: 'POST',
          body: JSON.stringify(credentials)
        });
        
        const data = await handleApiResponse(response);
        
        if (data.token) {
          commit('SET_TOKEN', data.token);
        }
        if (data.user) {
          commit('SET_USER', data.user);
          localStorage.setItem('user', JSON.stringify(data.user));
        }
        
        return data;
      } finally {
        commit('SET_AUTH_LOADING', false);
      }
    },
    
    async logout({ commit }) {
      // Call logout endpoint if token exists
      const token = localStorage.getItem('token');
      if (token) {
        try {
          await apiRequest(API_ENDPOINTS.LOGOUT, {
            method: 'POST'
          });
        } catch (error) {
          console.error('Logout error:', error);
        }
      }
      commit('LOGOUT');
    },
    
    async checkAuth({ commit }) {
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user');
      
      if (!token) {
        commit('LOGOUT');
        return false;
      }
      
      commit('SET_TOKEN', token);
      
      if (user) {
        try {
          const userData = JSON.parse(user);
          commit('SET_USER', userData);
        } catch (error) {
          console.error('Error parsing user data:', error);
        }
      }
      
      // Verify token with API
      try {
        commit('SET_AUTH_LOADING', true);
        const response = await apiRequest(API_ENDPOINTS.USER, {
          method: 'GET'
        });
        
        const userData = await handleApiResponse(response);
        commit('SET_USER', userData);
        localStorage.setItem('user', JSON.stringify(userData));
        return true;
      } catch (error) {
        console.error('Token verification failed:', error);
        commit('LOGOUT');
        return false;
      } finally {
        commit('SET_AUTH_LOADING', false);
      }
    },
  },
  getters: {
    isAuthenticated: state => state.isAuthenticated,
    currentUser: state => state.user,
    authToken: state => state.token,
    authLoading: state => state.authLoading,
  },
});
